//GeneratorFlag:[NoChange]
import PersonNationality from './person-nationality';
import PersonNationalityFilter from './person-nationality-filter';

export default {PersonNationality, PersonNationalityFilter}
export{PersonNationality, PersonNationalityFilter}